// @ts-nocheck
import {
  Box,
  SimpleGrid,
  Skeleton,
  Text,
  Icon,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import { PlayerCard } from "../../Components/PlayerCard";
import Layout from "../../Components/Layout";
import { useHome } from "./userHome";
import { FaFutbol } from "react-icons/fa";

export const Home = (): JSX.Element => {
  const { error, loading, players, ownGoals } = useHome();
  const isShowPlayers = true;

  return (
    <Layout title="Ranking por Gols">
      {isShowPlayers ? (
        <Tabs variant="enclosed" w="full">
          <TabList w="full">
            <Tab
              flex="1"
              textAlign="center"
              bg="white"
              color="black"
              _selected={{ bg: "primary.800", color: "primary.50" }}
            >
              <b>Artilheiros</b>
            </Tab>
            <Tab
              flex="1"
              textAlign="center"
              bg="white"
              color="black"
              _selected={{ bg: "primary.800", color: "primary.50" }}
            >
              <b>Gols Contra</b>
            </Tab>
          </TabList>

          <TabPanels>
            <TabPanel p={0}>
              {loading && (
                <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} spacing={4}>
                  {[...Array(6)].map((_, index) => (
                    <Skeleton key={index} height="150px" borderRadius="md" />
                  ))}
                </SimpleGrid>
              )}

              {!loading &&
                !error &&
                players?.data &&
                players.data.length > 0 && (
                  <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} p={4} gap={4}>
                    {players?.data?.map((player, index) => (
                      <PlayerCard
                        name={player?.user_name}
                        photoUrl={player?.user_photo_base64 ?? "/logo192.png"}
                        goals={parseInt(player?.total_goals)}
                        textGoal="Gols"
                        position={index + 1}
                      />
                    ))}
                  </SimpleGrid>
                )}

              {!loading && !error && players?.data?.length === 0 && (
                <Box textAlign="center" mt={4}>
                  <Text fontWeight="bold">Nenhum jogador encontrado.</Text>
                </Box>
              )}
            </TabPanel>

            <TabPanel p={0}>
              {!loading &&
                !error &&
                ownGoals?.data &&
                ownGoals.data.length > 0 && (
                  <SimpleGrid columns={{ base: 1, sm: 2, md: 3 }} p={4} gap={4}>
                    {ownGoals?.data?.map((player, index) => (
                      <PlayerCard
                        name={player?.user_name}
                        photoUrl={player?.user_photo_base64 ?? "/logo192.png"}
                        goals={parseInt(player?.total_own_goals)}
                        textGoal="Gols contra"
                        position={index + 1}
                        ownGoal={true}
                      />
                    ))}
                  </SimpleGrid>
                )}
            </TabPanel>
          </TabPanels>
        </Tabs>
      ) : (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          minH="60vh"
          p={4}
        >
          <Box textAlign="center">
            <Box display="flex" justifyContent="center" mb={4}>
              <Icon as={FaFutbol} boxSize={14} color="green.500" mr={3} />
            </Box>
            <Text fontWeight="bold" mt={4}>
              Ranking de jogadores está indisponível no momento.
            </Text>
            <Text fontWeight="medium" mt={4}>
              Em breve, traremos muitas novidades!
            </Text>
          </Box>
        </Box>
      )}
    </Layout>
  );
};
